/** client/src/App.js **/ 

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LandingPage from './LandingPage';
import AuthForm from './AuthForm';
import Dashboard from './Dashboard';

const API_URL = process.env.REACT_APP_API_URL;

axios.defaults.withCredentials = true;

function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState('login'); // 'login' | 'register' | 'dashboard'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/auth/me`)
      .then(res => {
        setUser(res.data.user);
        setView('dashboard');
      })
      .catch(() => {
        setUser(null);
        setView('login');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setView('dashboard');
  };

  const handleLogout = () => {
    axios.get(`${API_URL}/api/auth/logout`)
      .then(() => {
        setUser(null);
        setView('login');
      });
  };

  if (loading) return <p style={{ padding: 40 }}>Loading...</p>;

  if (!user && view === 'login') {
    return <AuthForm mode="login" onSuccess={handleLogin} switchMode={() => setView('register')} />;
  }

  if (!user && view === 'register') {
    return <AuthForm mode="register" onSuccess={handleLogin} switchMode={() => setView('login')} />;
  }

  if (user) {
    return <Dashboard user={user} onLogout={handleLogout} onSwitch={setView} />;
  }

  return <LandingPage />;
}

export default App;